import React from 'react';
import { makeStyles } from '@mui/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import DraftsIcon from '@mui/icons-material/Drafts';
import { green } from '@mui/material/colors';
import { createTheme, ThemeProvider } from '@mui/material/styles';


const theme = createTheme();

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
  },
  blue: {
    color: '#fff',
    backgroundColor: green[500],
  },
}));

export default function EnviaCorreo() {
  const classes = useStyles();
  return <ThemeProvider theme={theme}>
    <React.Fragment>
      <List className={classes.root}>
        <ListItem alignItems="flex-start">
          <ListItemAvatar>
              <Avatar className={classes.blue}>
                <DraftsIcon />
              </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Correo enviado correctamente"
            secondary="Para continuar el proceso debes seguir las instrucciones que hemos enviado a tu correo electrónico seleccionado anteriormente"
          />
        </ListItem>
      </List>
    </React.Fragment>
    </ThemeProvider>;
}